<div class="main-container public-view-container">
  
  <wm-applicant-home-drawer-heading
    [data]="{
      header: 'Welcome to ' + jurisdictionName + ' Online Permitting',
      subHeader: 'Informational sub hed with instruction on what to do from here?'
    }"
  ></wm-applicant-home-drawer-heading>

  <div class="department-tabs-outer">
    
    <button
      class="chevron-btn left"
      *ngIf="showBackward"
      (click)="scrollDepartments('left')"
    >
      <span class="material-icons">chevron_left</span>
    </button>

    <div class="department-tabs-wrapper" #deptContainer (scroll)="onDepartmentScroll()">
      <div class="department-tabs">
        <div 
          class="tab-item" 
          *ngFor="let dept of departments"
          [class.active]="activeDepartmentId === dept.id"
          (click)="selectDepartment(dept.id)"
          [matTooltip]="dept.label.length > 15 ? dept.label : ''"
          matTooltipClass="custom-tooltip-style"
          matTooltipPosition="above">
          <span class="material-icons">{{ dept.icon }}</span>
          <span class="tab-label">{{ dept.label }}</span>
        </div>
      </div>
    </div>

    <button
      class="chevron-btn right"
      *ngIf="showForward"
      (click)="scrollDepartments('right')"
    >
      <span class="material-icons">chevron_right</span>
    </button>
    
  </div>

  <div class="application-container">
    
    <div class="filter-header-wrapper" *ngIf="filtersReady">
      <wm-filter-builder
        id="publicViewFilters"
        class="public-filter-builder"
        [params]="filterCriteria"
        [defaultFilters]="[]"
        [filterTypes]="filterTypes"
        [savedFilters]="false"
        (filtersChange)="filtersChanged($event)"
        [useMuiLayout]="true"
        [showSimpleSearch]="true"
        simpleSearchTitle="Search"
        title=""
      >
        <ng-template #sortByTemplate>
          <div class="sort-by-wrapper" #sortWrapper>
            <button class="sort-btn" type="button" (click)="toggleSort($event)">
              Sort by | <span class="selected-sort-label">{{ selectedSortLabel }}</span>
              <span class="material-icons dropdown-icon">keyboard_arrow_down</span>
            </button>
        
            <div class="sort-menu" *ngIf="isSortOpen">
              <div
                class="sort-item"
                *ngFor="let item of SortByOptions"
                [class.active]="item === selectedSortOption"
                (click)="selectSort(item)"
              >
                {{ item }}
              </div>
            </div>
          </div>
        </ng-template>
      </wm-filter-builder>
    </div>

    <div class="table-card-wrapper">
      <wm-common-table
        [tableType]="'Applicant'"
        [isLoading]="isLoading"
        [loadingDataForApplication]="loadingDataForApplication"
        [loaderType]="'Skeleton'"
        [columns]="columns"
        [data]="data"
        [serverSidePagination]="true"
        [totalPages]="pageCount"
        [currentPage]="page"
        [pageSize]="pageSize"
        (pageChange)="onPageChange($event)"
        (rowsPerPageChange)="onRowsPerPageChange($event)"
        (sortChanged)="onSortChanged($event)"
        [showRowsPerPage]="true"
        [showTotalRecords]="true"
        [totalRecords]="totalRecords"
        [pageSizeStorageKey]="'public-view-page-size'"
      >
      </wm-common-table>
    </div>
  </div>
</div>